"use strict";
import $ from "jquery";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
export default {
  unApprove: function(loadShipmentId, carrier_invoice_id) {
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.post("/api/load_shipments/" + loadShipmentId + "/unapprove", {
        carrier_invoice_id
      }).then(function(data) {
        DataStoreService.updateStores(data);
        return data;
      })
    );
  }
};
